import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { setAutoRejectConfig } from './api/set-config';
import { getAutoRejectConfig } from './api/get-config';
import NumericInput from '../../common/inputs/customs/num-input-add';
import Switch from '../../common/inputs/customs/switch';
import { AnalyticsProvider } from 'app/scripts/services/analytics-provider';
import { sendEventHOC } from 'app/scripts/tracking/sendEventHOC';
import {
  createModerationThresholdChangedPayload,
  createSettingsChangedPayload
} from 'app/scripts/components/moderation/preferences/settings-send-event-utils';

const ITEM_NAME = 'Rejecting reported comments';

class RejectedCommentsCount extends Component {
  static displayName = 'RejectedCommentsCount';

  constructor(props, context) {
    super(props, context);
    this.state = {
      count: 3,
      isLoading: true,
      value: 0
    };
  }

  componentDidMount() {
    this.loadCount();
  }

  async loadCount() {
    const { spotId } = this.props;
    const body = await getAutoRejectConfig(spotId);
    const isEnabled = body && body.auto_reject_message_reports_enabled;
    const count = body && body.auto_reject_message_reports_threshold;

    // Hard coded cause the backend default value is 10k
    const isInitialCount = count === 10000;

    if (count) {
      this.setState({
        count: isInitialCount ? 3 : count,
        isLoading: false,
        isEnabled
      });
      return;
    }
    this.setState({
      isLoading: false
    });
  }

  async onClick(value) {
    const { spotId } = this.props;
    value = parseInt(value);
    value = isNaN(value) ? this.state.count : value;
    value = value < 1 ? 1 : value;

    AnalyticsProvider.track('rejecting reported comments save clicked', {
      enabled: true,
      count: value
    });

    let be_success = true;
    try {
      await setAutoRejectConfig(spotId, { counter: value, enabled: true });
    } catch (e) {
      be_success = false;
    }

    this.props.sendEvent(createModerationThresholdChangedPayload(ITEM_NAME, value, be_success));

    this.setState({
      count: value
    });
  }

  onChange(value) {
    this.setState({
      count: value
    });
  }

  async onSwitchChange(value) {
    const { spotId } = this.props;
    const { count } = this.state;

    AnalyticsProvider.track('rejecting reported comments clicked', {
      enabled: value,
      count: count
    });

    let be_success = true;
    try {
      await setAutoRejectConfig(spotId, { counter: count, enabled: value });
    } catch (e) {
      be_success = false;
    }

    this.props.sendEvent(createSettingsChangedPayload(ITEM_NAME, value, { be_success }));
    this.setState({ isEnabled: value });
  }

  render() {
    const { count, isLoading, isEnabled } = this.state;
    const value = parseInt(count);

    if (isLoading) {
      return null;
    }

    return (
      <div className="auto-reject-container">
        <Switch
          title="Rejecting reported comments"
          description="Comments which receive this number of reports will automatically be rejected."
          value={isEnabled}
          onChange={this.onSwitchChange.bind(this)}
        />
        {isEnabled && (
          <NumericInput
            onClick={this.onClick.bind(this)}
            onChange={this.onChange.bind(this)}
            disabledAddButton={false}
            value={value}
            status={'success'}
          />
        )}
      </div>
    );
  }
}

RejectedCommentsCount.propTypes = {
  spotId: PropTypes.string,
  sendEvent: PropTypes.func.isRequired
};

export default sendEventHOC(RejectedCommentsCount);
